import { ConfigProvider, type ThemeConfig } from "antd";
import { Provider as MotionProvider } from "rc-motion";
import type { ReactNode } from "react";
import { usePrefersReducedMotion } from "./usePrefersReducedMotion";

const reducedTheme: ThemeConfig = {
  token: {
    motionDurationFast: "0s",
    motionDurationMid: "0s",
    motionDurationSlow: "0s",
  },
};
const defaultTheme: ThemeConfig = {};

/** Keeps Ant Design overlays functional without animation when the OS requests reduced motion. */
export const ReducedMotionProvider = ({ children }: { children: ReactNode }) => {
  const reducedMotion = usePrefersReducedMotion();

  return (
    <ConfigProvider theme={reducedMotion ? reducedTheme : defaultTheme} wave={{ disabled: reducedMotion }}>
      {/*
       * Disable rc-motion's enter/leave lifecycle, rather than just shortening its CSS.
       * Keep this boundary mounted in both modes: toggling Ant Design's token.motion
       * inserts its own MotionWrapper on the first change and can remount unsaved forms.
       */}
      <MotionProvider motion={!reducedMotion}>{children}</MotionProvider>
    </ConfigProvider>
  );
};
